import { useEffect, useState } from 'react';
import { db } from "@react-native-firebase/database";
import { get, ref, set, update } from "firebase/database";
import StyleSheetRW from 'core/StyleSheetRW';
import { Dimensions, ScrollView, Text, TextInput, TouchableOpacity, View } from 'react-native';
import { MOBILE_VIEW_WIDTH } from "res/constants";
import DateField from 'src/components/DateField';
import DropDownField from 'src/components/DropDownField';
import { DropDownOptionsCities, DropDownOptionsEmploymentRole, DropDownOptionsEmploymentStatus, DropDownOptionsEmploymentType, DropDownOptionsGenders } from 'src/utils/DropDownOptionsUtils';
import Menu from './Menu';
import { getLocalStorageItem } from 'core/helpers';
import Dialog from 'src/components/Dialog';
import Loader from 'src/components/Loader';
import navhelper from 'core/navhelper';
import { getCurrentUserId } from './UserDetailsScreen';
import storage from '@react-native-firebase/storage';
import { BsPenFill } from 'react-icons/bs';
import { textFieldFilteration } from 'src/utils/TextFieldUtils';
import { userExperienceLetter } from 'src/utils/PDFReportUtils';
import profileIcon from "res/svgs/menu_profile.svg";

interface UserProfileScreen {
  editUser: boolean
}
const UserProfileScreen = ({ editUser }: UserProfileScreen) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    email: '',
    gender: '',
    DOB: '',
    phone: '',
    employmentType: '',
    employmentRole: '',
    employmentStatus: '',
    employeeJoiningDate: '',
    employeeResignationDate: "",
    nextToKin: {
      name: '',
      relation: '',
      contact: '',
      userTypeId: 2
    },
    image: ''
  });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [showImageEditIcon, setShowImageEditIcon] = useState(false)
  const screenWidth = Dimensions.get('window').width;
  const loggedinUser = getLocalStorageItem("loggedinUser");
  const [imageUploaded, setImageUploaded] = useState(false)
  const handleSelectImage = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setImageUploaded(true)
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          image: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const handleChange = (name: string, value: string, type: string) => {
    let filteredValue = textFieldFilteration(value, type)
    if (name.includes('nextToKin')) {
      const nextOfKinField = name.split('.')[1];
      setFormData({
        ...formData,
        nextToKin: {
          ...formData.nextToKin,
          [nextOfKinField]: filteredValue,
        },
      });
    } else {
      setFormData({
        ...formData,
        [name]: filteredValue,
        email: userEmail,
      });
    }
  };


  const handleSubmit = async () => {
    setShowLoader(true);
    if (loggedinUser) {
      try {
        if (formData.image && imageUploaded === true) {
          const file = await fetch(formData.image);
          const blob = await file.blob();
          const userId = !editUser ? loggedinUser.uid : getCurrentUserId();
          const imageRef = storage().ref(`profile_images/${userId}`);
          await imageRef.putFile(blob);
          const downloadURL = await imageRef.getDownloadURL();
          setFormData((prevFormData) => ({ ...prevFormData, image: downloadURL }));
        }
  
        const updatedFormData = { ...formData };
  //these filed that only change or fill by admin
        const optionalFields = [
          'employmentType',
          'employmentRole',
          'employmentStatus',
          'employeeJoiningDate',
          'employeeResignationDate'
        ];
  
        const allFieldsFilled = Object.entries(updatedFormData).every(([key, value]) => {
          if (optionalFields.includes(key)) {
            return true;
          }
          if (key === 'nextToKin') {
            return Object.entries(value).every(([subKey, subValue]) => {
              if (subKey === 'name') {
                return true;
              }
              return subValue !== '';
            });
          }
          return value !== '';
        });
  
        if (!allFieldsFilled) {
          setShowLoader(false);
          setShowToast(true);
          setToastMessage("Please fill in all required fields.");
          return;
        }
  
        if (!editUser) {
          const dbRef = ref(db, `profile/${loggedinUser.uid}`);
          console.log(updatedFormData);
          await set(dbRef, updatedFormData)
            .then(() => {
              setShowLoader(false);
              setShowToast(true);
              setToastMessage("Profile updated successfully");
            })
            .catch((error) => {
              setShowLoader(false);
              console.error("Error updating profile:", error);
              setShowToast(true);
              setToastMessage(`Error updating profile: ${error}`);
            });
        } else {
          const dbRef = ref(db, `profile/${getCurrentUserId()}`);
          await update(dbRef, updatedFormData)
            .then(() => {
              setShowLoader(false);
              setShowToast(true);
              setToastMessage("Profile updated successfully");
            })
            .catch((error) => {
              setShowLoader(false);
              console.error("Error updating profile:", error);
              setShowToast(true);
              setToastMessage(`Error updating profile: ${error}`);
            });
        }
      } catch (error) {
        setShowToast(true);
        setToastMessage(`Error updating profile: ${error}`);
        setShowLoader(false);
      }
    }
  };
  
  

  useEffect(() => {
    setShowLoader(true)
    const fetchUserData = async () => {
      if (loggedinUser) {
        if (!editUser) {
          const dbRef = ref(db, `profile/${loggedinUser.uid}`);
          const snapshot = await get(dbRef);
          if (snapshot.exists()) {
            setShowLoader(false)
            setFormData(snapshot.val());
          } else {
            setShowLoader(false)
          }
        }
        else {
          const dbRef = ref(db, `profile/${getCurrentUserId()}`);
          const snapshot = await get(dbRef);
          if (snapshot.exists()) {
            setShowLoader(false)
            setFormData(snapshot.val());
            setUserEmail(snapshot.val().email)
          } else {
            setShowLoader(false)
          }
        }
      }
    };
    if (!editUser) {
      setUserEmail(loggedinUser?.email);
    }
    fetchUserData();
  }, []);
const userName=`${formData.firstName} ${formData.lastName}`

  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100%', overflow: "hidden" }}>
      <Menu backEnabled={editUser ? true : false} />
      <View style={styles.container}>
        <ScrollView showsVerticalScrollIndicator={false} showsHorizontalScrollIndicator={false} style={{ padding: 20, width: screenWidth < MOBILE_VIEW_WIDTH ? "100%" : "80%" }}>
          <View style={styles.header}>
            <Text style={editUser === true && screenWidth < MOBILE_VIEW_WIDTH ? styles.heading : styles.heading2}>Profile</Text>
            {screenWidth > MOBILE_VIEW_WIDTH && (
              <TouchableOpacity style={styles.button} onPress={handleSubmit}>
                <Text style={styles.buttonText}>Save Changes</Text>
              </TouchableOpacity>
            )}
          </View>
          <View style={styles.form}>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={styles.inputContainer}>
                <label htmlFor="imageInput" style={{ cursor: 'pointer' }}>
                  {formData.image ? (
                    <div style={{ height: 200, width: 200, borderRadius: 100, display: 'flex', justifyContent: 'center', alignItems: 'center' }} onMouseEnter={() => setShowImageEditIcon(true)} onMouseLeave={() => setShowImageEditIcon(false)}>
                      <img src={formData.image} style={{ height: 200, width: 200, borderRadius: 100,objectFit:'cover' }} />
                      {showImageEditIcon === true && <BsPenFill style={{ width: 40, height: 40, position: 'absolute', alignSelf: 'center' }} />}
                    </div>
                  ) : (
                    <div style={{ height: 200, width: 200, borderRadius: 100, border: '2px dashed #999', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <BsPenFill style={{ width: 40, height: 40 }} />
                    </div>
                  )}
                </label>
                <input
                  id="imageInput"
                  type="file"
                  accept="image/*"
                  onChange={handleSelectImage}
                  style={{ display: 'none' }}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', gap: screenWidth <= MOBILE_VIEW_WIDTH ? 10 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>First Name</Text>
                <TextInput
                  style={styles.input}
                  placeholder="First Name"
                  value={formData.firstName}
                  onChangeText={(text) => handleChange('firstName', text, 'text')}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Last Name</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Last Name"

                  value={formData.lastName}
                  onChangeText={(text) => handleChange('lastName', text, 'text')}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', gap: screenWidth <= MOBILE_VIEW_WIDTH ? 10 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Address</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Address"
                  value={formData.address}
                  onChangeText={(text) => handleChange('address', text, 'alphanumeric')}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>City</Text>
                <DropDownField
                  value={formData.city}
                  placeholder="Please Select a City"
                  placeholderTextColor={"rgb(109,126,124)"}
                  bodyStyle={{ marginHorizontal: 0 }}
                  options={DropDownOptionsCities}
                  onChangeText={(text) => handleChange('city', text, 'text')}
                  label="City"
                  showSearchBar={true}
                  isCloseOnSelection={true}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', marginBottom: screenWidth > MOBILE_VIEW_WIDTH ? 0 : 10, gap: screenWidth <= MOBILE_VIEW_WIDTH ? 0 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Gender</Text>
                <DropDownField
                  value={formData.gender}
                  placeholder="Gender"
                  placeholderTextColor={"rgb(109,126,124)"}
                  bodyStyle={{ marginHorizontal: 0 }}
                  options={DropDownOptionsGenders}
                  onChangeText={(text) => handleChange('gender', text, 'text')}
                  label="Gender"
                  isCloseOnSelection={true}
                />
              </View>
              <View style={{ ...styles.inputContainer, paddingRight: screenWidth < MOBILE_VIEW_WIDTH ? "10px" : "" }}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Date of Birth</Text>
                <DateField
                  value={formData.DOB}
                  placeholder="MM-DD-YYYY"
                  onChangeText={(text) => handleChange('DOB', text, 'date')}
                  style={{ width: '100%' }}
                  label=''
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', gap: screenWidth <= MOBILE_VIEW_WIDTH ? 10 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Phone</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Phone"
                  value={formData.phone}
                  onChangeText={(text) => handleChange('phone', text, 'number')}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Email</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Email"
                  value={editUser ? formData.email : userEmail}
                  editable={false}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', gap: screenWidth <= MOBILE_VIEW_WIDTH ? 10 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Employment Type</Text>
                {editUser ? (
                  <DropDownField
                    value={formData.employmentType}
                    placeholder="Employment Type"
                    placeholderTextColor={"rgb(109,126,124)"}
                    bodyStyle={{ marginHorizontal: 0 }}
                    options={DropDownOptionsEmploymentType}
                    onChangeText={(text) => handleChange('employmentType', text, 'text')}
                    label="employmentType"
                    isCloseOnSelection={true}
                    editable={editUser ? true : false}
                  />
                ) : (
                  <TextInput
                    style={styles.input}
                    placeholder="Employment Type"
                    value={formData.employmentType}
                    editable={false}
                  />
                )}
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Employment Role</Text>
                {editUser ? (
                  <DropDownField
                    value={formData.employmentRole}
                    placeholder="Employment Role"
                    placeholderTextColor={"rgb(109,126,124)"}
                    bodyStyle={{ marginHorizontal: 0 }}
                    options={DropDownOptionsEmploymentRole}
                    onChangeText={(text) => handleChange('employmentRole', text, 'text')}
                    label="employmentRole"
                    isCloseOnSelection={true}
                    editable={editUser ? true : false}
                  />
                ) : (
                  <TextInput
                    style={styles.input}
                    placeholder="Employment Role"
                    value={formData.employmentRole}
                    editable={false}
                  />
                )}
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', gap: screenWidth <= MOBILE_VIEW_WIDTH ? 10 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Employment Status</Text>
                {editUser ? (
                  <DropDownField
                    value={formData.employmentStatus}
                    placeholder="Employment Status"
                    placeholderTextColor={"rgb(109,126,124)"}
                    bodyStyle={{ marginHorizontal: 0 }}
                    options={DropDownOptionsEmploymentStatus}
                    onChangeText={(text) => handleChange('employmentStatus', text, 'text')}
                    label="employmentType"
                    isCloseOnSelection={true}
                    editable={editUser ? true : false}
                  />
                ) : (
                  <TextInput
                    style={styles.input}
                    placeholder="Employment Status"
                    value={formData.employmentStatus}
                    editable={false}
                  />
                )}
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 0 }}>Employee Joining Date</Text>
                {editUser ? (
                  <DateField
                    value={formData.employeeJoiningDate}
                    placeholderTextColor={"rgb(109,126,124)"}
                    onChangeText={(text) => handleChange('employeeJoiningDate', text, 'date')}
                    placeholder='Employee Joining Date'
                    label=''
                  />
                ) : (
                  <TextInput
                    style={styles.input}
                    placeholder="Employee Joining Date"
                    value={formData.employeeJoiningDate}
                    editable={false}
                  />
                )}
              </View>
            </View>
            {editUser &&
              <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', marginBottom: 0 }}>
                <View style={styles.inputContainer}>
                  <Text style={{ ...styles.label, marginTop: 5 }}>Employee Resignation Date</Text>
                  <DateField
                    value={formData.employeeResignationDate}
                    placeholderTextColor={"rgb(109,126,124)"}
                    onChangeText={(text) => handleChange('employeeResignationDate', text, 'date')}
                    placeholder='Employee Resignation Date'
                    style={{ width: screenWidth < MOBILE_VIEW_WIDTH ? '100%' : '48.5%' }}
                    label=''
                  />
                </View>
              </View>
            }
            {formData.employeeResignationDate !== "" &&  !editUser && (
              <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', marginBottom: 0 }}>
                <View style={styles.inputContainer}>
                  <Text style={{ ...styles.label, marginTop: 5 }}>Employee Resignation Date</Text>
                  <TextInput
                    style={{ ...styles.input, width: screenWidth < MOBILE_VIEW_WIDTH ? '100%' : '48.5%' }}
                    placeholder="Employee Resignation Date"
                    value={formData.employeeResignationDate}
                    editable={false}
                  />
                </View>
              </View>
            )}
            <View style={[styles.row, { flexDirection: 'row' }]}>
              <Text style={styles.subheading}>Next of Kin</Text>
              <View style={[styles.line, { flex: 1, marginLeft: 5, marginTop: 20 }]}></View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', gap: screenWidth <= MOBILE_VIEW_WIDTH ? 10 : 20 }}>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Name (optional)</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Name"
                  value={formData.nextToKin.name}
                  onChangeText={(text) => handleChange('nextToKin.name', text, 'text')}
                />
              </View>
              <View style={styles.inputContainer}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Relation</Text>
                <TextInput
                  style={styles.input}
                  placeholder="Relation"
                  value={formData.nextToKin.relation}
                  onChangeText={(text) => handleChange('nextToKin.relation', text, 'text')}
                />
              </View>
            </View>
            <View style={{ ...styles.row, flexDirection: screenWidth < MOBILE_VIEW_WIDTH ? 'column' : 'row', }}>
              <View style={{...styles.inputContainer,}}>
                <Text style={{ ...styles.label, marginTop: 5 }}>Contact</Text>
                <TextInput
                  style={{ ...styles.input, width: screenWidth < MOBILE_VIEW_WIDTH ? '100%' : '48.5%' }}
                  placeholder="Contact"
                  value={formData.nextToKin.contact}
                  onChangeText={(text) => handleChange('nextToKin.contact', text, 'number')}
                />
              </View>
            </View>
            {editUser&&
            <div style={{ width: '100%', height: 20 }}>
                        <button  style={styles.buttonStyle} onClick={()=>userExperienceLetter(userName,formData.employeeJoiningDate,formData.employeeResignationDate,formData.employmentRole)}>
                            <div style={styles.buttonText}>Export Experience Letter</div></button>
                    </div>}
            {screenWidth < MOBILE_VIEW_WIDTH && (
              <TouchableOpacity style={{ ...styles.button, marginBottom: 10 }} onPress={handleSubmit}>
                <Text style={styles.buttonText}>Save Changes</Text>
              </TouchableOpacity>
            )}
          </View>
        </ScrollView>
      </View>

      <Dialog
        message={toastMessage}
        isDialogVisible={showToast}
        handleDialogConfirm={() => {
          if (toastMessage.includes('updated')) {
            setShowToast(false)
            if (!editUser) {
              navhelper.push('HomeScreen')
            }
            else {
              navhelper.push('AdminHomeScreen')
            }
          }
          setShowToast(false)
        }}
      />

      {
        showLoader && (
          <Loader />
        )
      }
    </div>
  );
};

const styles = StyleSheetRW.create(() => ({
  container: {
    flex: 1,
    width: "100%",
    height: "100%",
  },
  buttonStyle: {
    backgroundColor: '#2F4858',
    borderWidth: 0,
    paddingBottom: 10,
    paddingTop: 10,
    paddingLeft: 20,
    paddingRight: 20,
    cursor: 'pointer',
    position: 'absolute',
  left:0,
    borderRadius: 100,
    marginTop:10
},
buttonText: {
    color: 'white',
    fontWeight: "300",
    textAlign: "center"
},
  heading: {
    fontFamily: "Outfit",
    fontSize: 32,
    fontWeight: 'bold',
    color: "#2F4858",
    width: '100%',
    textAlign: 'center'
  },
  heading2: {
    fontFamily: "Outfit",
    fontSize: 32,
    fontWeight: '700',
    color: "#2F4858",
    textAlign: 'left'
  },
  subheading: {
    fontFamily: 'Outfit',
    fontSize: 18,
    fontWeight: 'bold',
    color: '#2F4858',
    marginTop: 10,
  },
  form: {
    width: '100%',
    height: '100%',
    marginTop: 20,
  },
  row: {
    justifyContent: 'space-between',
    marginBottom: 10,
    gap: 20
  },
  inputContainer: {
    flex: 1,
    marginRight: 5,
  },
  label: {
    fontFamily: 'Outfit',
    fontSize: 14,
    fontWeight: '600',
    lineHeight: 17.64,
    textAlign: 'left',
    marginBottom: 5,
    color: '#333333',
  },
  input: {
    height: 50,
    borderRadius: 10,
    paddingHorizontal: 10,
    backgroundColor: '#0000000D',
    marginTop: 3,
    placeholderTextColor: '#333333',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    backgroundColor: '#2F4858',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
  },
  buttonText: {
    color: 'white',
    fontWeight: "300",
    textAlign: "center",
  },
  line: {
    borderBottomWidth: 1,
    borderColor: '#2F4858',
    marginBottom: 10,
  },
}))

export default UserProfileScreen;